<template>
  <div class="reg">
    <el-container>
      <el-header :style="{ height: headHeight + 'px' }">
        <elheader></elheader>
      </el-header>
      <el-main :style="{ 'min-height': mainHeight + 'px' }">
        <div class="loginForm">
          <div :class="step == 1 ? 'stepLine after step1' : 'stepLine after step2'">
            <dl class="dl1">
              <dt>1</dt>
              <dd>账户注册</dd>
            </dl>
            <dl class="dl2">
              <dt>2</dt>
              <dd>信息登记</dd>
            </dl>
          </div>
          <div class="formBox" v-show="step == 1">
            <div class="form">
              <h3 class="title">注册</h3>
              <ul>
                <li class="pl95 phone_li">
                  <i class="iconfont icon-shouji1"></i>
                  <span>+86</span>
                  <input type="text" placeholder="11位手机号" v-model="phone"   />
                </li>
                <li class="pl40 pr120">
                  <i class="iconfont icon-yanjing1"></i>
                  <input type="text" placeholder="验证码" v-model="code" />
                  <sendCode :phone="phone" :isRegister="true"></sendCode>
                </li>
                <li class="pl40">
                  <i class="iconfont icon-yanjing1"></i>
                  <input type="password" placeholder="6 - 16位密码，区分大小写" v-model="password" />
                </li>
                <li class="pl40">
                  <i class="iconfont icon-yanjing1"></i>
                  <input
                    type="password"
                    placeholder="确认密码"
                    v-model="password_confirmation"
                    @keyup.13="registerBtn"
                  />
                </li>
                <li class="borb0 poi">
                  <button class="loginBtn" @click="registerBtn">注册</button>
                </li>
              </ul>
            </div>
            <div class="tip">
              使用已有账户，
              <router-link to="/login">
                <span class="poi">登录</span>
              </router-link>
            </div>
          </div>
          <!-- 注册 -->
          <div class="formBox" v-show="step == 2">
            <div class="form form2">
              <ul>
                <li class="item_li">
                  <div class="item_left">
                    <i class="iconfont icon-bao-copy"></i>
                    <span class="span_li">机构类型</span>
                  </div>
                  <el-select
                    class="flex-grow padding-left-15"
                    v-model="type"
                    @change="getType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in types"
                      :key="item.id"
                      :label="item.type_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </li>
                <li class="tips_li borb0">机构类型一旦选择无法修改，请谨慎选择</li>
                <li
                  v-show="type"
                  class="item_li"
                  v-for="(items,indexs) in zsList"
                  :key="indexs+items"
                >
                  <div class="item_left">
                    <i class="iconfont icon-yingyezhizhao"></i>
                    <span class="span_li">名片类型</span>
                  </div>
                  <div class="jy_picker flex-grow flex padding-left-15">
                    <el-select
                      class="flex-one"
                      v-model="items.second_level"
                      @change="threeType($event, indexs)"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in items.types_two"
                        :key="item.id"
                        :label="item.type_name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <el-select
                      class="flex-one"
                      v-model="items.three_level"
                      @change="fourType($event, indexs)"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in items.types_three"
                        :key="item.id"
                        :label="item.type_name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <el-select
                      class="flex-one"
                      v-model="items.four_level"
                      @change="fourChange($event,indexs)"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in items.types_four"
                        :key="item.id"
                        :label="item.type_name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="handle">
                    <i class="iconfont icon-jiahao" @click="addzs(indexs)"></i>
                    <i class="iconfont icon-jian" @click="remzs(indexs)"></i>
                  </div>
                </li>
                <li class="item_li">
                  <div class="item_left">
                    <i class="iconfont icon-jianjie"></i>
                    <span class="span_li">业务手机</span>
                  </div>
                  <div class="item_right flex-grow">
                    <input type="text" v-model="sms_phone"   placeholder="此手机号用于接收招商申请通知短信" />
                  </div>
                </li>
                <li class="item_li" v-for="(item,index) in objClass" :key="index">
                  <div class="item_left">
                    <i v-if="!item.icon" class="iconfont icon-loudong"></i>
                    <img v-if="item.icon" class="iconImg" :src="item.icon" />
                    <span class="span_li">{{item.c_name}}</span>
                  </div>
                  <div class="item_right flex-grow">
                    <!-- 手机号 -->
                    <input
                      v-if="item.field_type == 1"
                      type="text"
                      v-model="objValue[item.field_name]"
                       
                      :placeholder="item.tips"
                    />
                    <!-- 年月日 -->
                    <div v-if="item.field_type == 2">
                      <el-date-picker
                        v-model="objValue[item.field_name]"
                        type="date"
                        placeholder="选择日期"
                      ></el-date-picker>
                    </div>
                    <!-- 年月日时分秒 -->
                    <div v-if="item.field_type == 3">
                      <el-date-picker
                        v-model="objValue[item.field_name]"
                        type="datetime"
                        placeholder="选择日期时间"
                      ></el-date-picker>
                    </div>
                    <!-- 单行文本 -->
                    <input
                      v-if="item.field_type == 4"
                      type="text"
                      maxlength="200"
                      v-model="objValue[item.field_name]"
                      :placeholder="item.tips"
                    />
                    <!-- 多行文本 -->
                    <textarea
                      rows="3"
                      v-if="item.field_type == 5"
                      v-model="objValue[item.field_name]"
                      :placeholder="item.tips"
                    ></textarea>
                    <!-- 单图 -->
                    <div class="uploadBox" v-if="item.field_type == 6">
                      <el-upload
                        v-model="objValue[item.field_name]"
                        class="avatar-uploader"
                        action=" http://glc.ilianpei.com/common/upload/image/qiniu"
                        :http-request="myUpload"
                        accept="image/png, image/jpg, image/jpeg"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                      >
                        <img v-if="thumb" :src="thumb" class="avatar" />
                        <i v-if="addShow" class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <li class="tips_li borb0">{{item.tips}}</li>
                    </div>
                    <!-- 文字编辑器 -->
                    <div class="flex-grow" v-if="item.field_type == 7">
                      <quill-editor
                        v-model="objValue[item.field_name]"
                        ref="myQuillEditor"
                        :options="editorOption"
                        @blur="onEditorBlur($event)"
                        @focus="onEditorFocus($event)"
                        @change="onEditorChange($event, item.field_name)"
                      ></quill-editor>
                    </div>
                    <!-- 图文编辑器 -->
                    <div class="flex-grow" v-if="item.field_type == 8">
                      <quill-editor
                        v-model="objValue[item.field_name]"
                        ref="myQuillEditor"
                        :options="editorOptions"
                        @blur="onEditorBlurs($event)"
                        @focus="onEditorFocuss($event)"
                        @change="onEditorChanges($event, item.field_name)"
                      ></quill-editor>
                    </div>
                    <!-- 单选 -->
                    <div class="flex-grow line-40" v-if="item.field_type == 9">
                      <el-radio
                        v-for="(items,indexs) in item.label_yiji"
                        :key="indexs"
                        v-model="objValue[item.field_name]"
                        :label="items.id"
                      >{{items.title}}</el-radio>
                    </div>
                    <!-- 多选 -->
                    <div class="flex-grow line-40" v-if="item.field_type == 10">
                      <el-checkbox-group
                        v-for="(items,indexs) in item.label_yiji"
                        :key="indexs"
                        v-model="objValue[item.field_name]"
                      >
                        <el-checkbox :label="items.id">{{items.title}}</el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <!-- 多级联动 -->
                    <div class="flex-grow line-40 flex" v-if="item.field_type == 11">
                      <el-select
                        class="flex-one"
                        v-model="objValue[item.field_name][0]"
                        @change="objOneChange($event, item.label_yiji, item.field_name)"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(items,indexs) in item.label_yiji"
                          :key="indexs"
                          :label="items.title"
                          :value="items.id"
                        ></el-option>
                      </el-select>
                      <!-- 二级 -->
                      <el-select
                        class="flex-one"
                        v-if="classList[item.field_name]"
                        v-model="objValue[item.field_name][1]"
                        @change="objTwoChange($event, classList[item.field_name][0], item.field_name)"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(items,indexs) in classList[item.field_name][0]"
                          :key="indexs"
                          :label="items.title"
                          :value="items.id"
                        ></el-option>
                      </el-select>
                      <!-- 三级 -->
                      <el-select
                        class="flex-one"
                        v-if="classList[item.field_name] && item.cate_level > 2"
                        v-model="objValue[item.field_name][2]"
                        @change="objThreeChange"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(items,indexs) in  classList[item.field_name][1]"
                          :key="indexs"
                          :label="items.title"
                          :value="items.id"
                        ></el-option>
                      </el-select>
                    </div>
                    <!-- 地区 -->
                    <div class="flex-grow flex line-40" v-if="item.field_type == 13">
                      <el-select
                        class="flex-one"
                        v-model="objValue[item.field_name][0]"
                        placeholder="请选择"
                        @change="provinceChange($event, item.field_name)"
                      >
                        <el-option
                          v-for="item in province"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                      <el-select
                        class="flex-one"
                        v-model="objValue[item.field_name][1]"
                        placeholder="请选择"
                        @change="cityChange($event, item.field_name)"
                      >
                        <el-option
                          v-for="item in city"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                      <el-select
                        class="flex-one"
                        v-model="objValue[item.field_name][2]"
                        placeholder="请选择"
                        @change="areaChange($event, item.field_name)"
                      >
                        <el-option
                          v-for="item in area"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </div>
                    <span class="xing">{{item.is_notnull == 1 ? '*' : ''}}</span>
                  </div>
                </li>
                <li class="item_li">
                  <div class="item_left">
                    <i class="iconfont icon-jianjie"></i>
                    <span class="span_li">公司简介</span>
                  </div>
                  <div class="item_right flex-grow">
                    <textarea rows="3" placeholder="请输入公司简介" v-model="enterprise_content"></textarea>
                  </div>
                </li>
                <div style="text-align:right;font-size: 14px;color: #999;margin-top: 20px;">以上带*号为必填项</div>
                <li class="borb0">
                  <button class="loginBtn poi" @click="sub">继续</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-main>
      <el-footer :style="{ height: footHeight + 'px' }">
        <elfooter></elfooter>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import elheader from "../../components/loginHeader"; //头部
import elfooter from "../../components/loginFooter"; //底部
import sendCode from "../../components/sendCode"; //获取验证码
import { checkedPhone, confirmPwd, checkPwd } from "../../util/login"; //手机号码 密码验证
// import enlargePic from "../../components/enlargePic.vue";
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
  ["blockquote", "code-block"], //引用，代码块

  [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
  [{ list: "ordered" }, { list: "bullet" }], //列表
  [{ script: "sub" }, { script: "super" }], // 上下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  [{ direction: "rtl" }], // 文本方向

  [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题

  [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
  [{ font: [] }], //字体
  [{ align: [] }], //对齐方式

  ["clean"] //清除字体样式
];
export default {
  components: {
    elheader,
    elfooter,
    sendCode
  },
  data() {
    var that = this;
    return {
      addShow: true,
      // 公共参数
      token: window.localStorage.getItem("pc_token"),
      headHeight: 80,
      footHeight: 50,
      mainHeight: 0,
      // 注册
      step: 1,
      phone: "", //手机号
      code: "", //验证码
      password: "", //密码
      password_confirmation: "", //重复密码
      // 完善信息
      thumb: "", //缩略图
      types: [], // 企业类型
      type: "",
      zsList: [
        {
          types_two: [], //二级分类
          second_level: "",
          types_three: [], // 三级分类
          three_level: "",
          types_four: [], // 四级分类
          four_level: ""
        }
      ],
      objClass: "", // 十三中分类
      objValue: {}, // 十三种分类的v-model
      editorOption: {
        placeholder: "请输入",
        modules: {
          toolbar: toolbarOptions
        }
      }, // 富文本配置 文本编辑器
      editorOptions: {
        placeholder: "请输入"
      }, // 图文编辑器
      province: "", // 省
      city: "", // 市
      area: "", // 区
      classList: {},
      a: {},
      enterprise_content: "",
      sms_phone: ""
    };
  },
  created() {
    this.isToken(); //获取token
    if (this.step == 2) {
      this.getClass();
      this.getProvince();
    }
  },
  methods: {
    e(ed) {
      console.log(ed);
    },
    //   获取类型
    getClass() {
      this.post(this, "/home/organization", {
        token: window.localStorage.getItem("pc_token")
      }).then(res => {
        this.types = res.data.data;
      });
    },
    // 获取固定类型和十三中类型
    getType() {
      this.zsList = [
        {
          types_two: [], //二级分类
          second_level: "",
          types_three: [], // 三级分类
          three_level: "",
          types_four: [], // 四级分类
          four_level: ""
        }
      ];
      this.post(this, "/home/canvassType", {
        token: window.localStorage.getItem("pc_token"),
        otype_id: this.type
      }).then(res => {
        // 固定类型
        this.objValue = {};
        for (let j in this.zsList) {
          this.zsList[j].types_two = res.data.data.attract;
        }
        for (let i in res.data.data.field) {
          // 在每个原数据添加自己field的属性
          res.data.data.field[i][res.data.data.field[i].field_name] = "";
          // 设置自有属性 放到一个空数组 值初始化
          if (
            res.data.data.field[i].field_type == 10 ||
            res.data.data.field[i].field_type == 13 ||
            res.data.data.field[i].field_type == 11
          ) {
            this.$set(this.objValue, res.data.data.field[i].field_name, []);
          } else {
            this.$set(this.objValue, res.data.data.field[i].field_name, "");
          }
        }
        this.objClass = res.data.data.field;
      });
    },
    // 获取三级分类
    threeType(id, index) {
      this.zsList[index].types_three = []
      this.zsList[index].three_level = ""
      this.zsList[index].types_four = []
      this.zsList[index].four_level = ""

      for (let i in this.zsList[index].types_two) {
        if (id == this.zsList[index].types_two[i].id) {
          this.zsList[index].types_three = this.zsList[index].types_two[
            i
          ].Ent_type_3;
        }
      }
    },
    fourType(id, index) {
      this.zsList[index].types_four = []
      this.zsList[index].four_level = ""

      for (let i in this.zsList[index].types_three) {
        if (id == this.zsList[index].types_three[i].id) {
          this.zsList[index].types_four = this.zsList[index].types_three[
            i
          ].Ent_type_4;
        }
      }
    },
    // 11多级分类
    objOneChange(id, fid, name) {
      this.objValue[name][1] = "";
      this.objValue[name][2] = "";
      for (let i in fid) {
        if (id == fid[i].id) {
          this.post(this, "/common/lowerLevel", {
            id: id,
            manage_id: fid[i].manage_id
          }).then(res => {
            this.$set(this.classList, name, [res.data.data]);
          });
        }
      }
    },
    objTwoChange(id, fid, name) {
      this.classList[name][1] = "";
      this.objValue[name][2] = "";
      for (let i in fid) {
        if (id == fid[i].id) {
          this.post(this, "/common/lowerLevel", {
            id: id,
            manage_id: fid[i].manage_id
          }).then(res => {
            this.$set(this.classList[name], 1, res.data.data);
          });
        }
      }
    },
    objThreeChange(id) {},
    // 添加招商类型
    addzs(index) {
      if (this.zsList.length > 9) {
        this.$message.success("最多只能添加10个");
        return false;
      }
      this.zsList.push({
        types_two: [], //二级分类
        second_level: "",
        types_three: [], // 三级分类
        three_level: "",
        types_four: [], // 四级分类
        four_level: ""
      });
      this.post(this, "/home/canvassType", {
        token: window.localStorage.getItem("pc_token"),
        otype_id: this.type
      }).then(res => {
        // 固定类型
        for (let j in this.zsList) {
          this.zsList[j].types_two = res.data.data.attract;
        }
      });
    },
    remzs(index) {
      if (this.zsList.length == 1) {
        this.$message.success("最少要添加一个");
        return false;
      }
      this.zsList.splice(index, 1);
    },
    // 地址
    getProvince() {
      this.post(this, "/common/getRegion", {
        id: 0
      }).then(res => {
        this.province = res.data.data;
      });
    },
    provinceChange(e, name) {
      this.objValue[name][1] = "";
      this.objValue[name][2] = "";
      this.city = "";
      this.area = "";
      this.post(this, "/common/getRegion", {
        id: e
      }).then(res => {
        this.city = res.data.data;
      });
    },
    cityChange(e, name) {
      this.objValue[name][2] = "";
      this.area = "";
      this.post(this, "/common/getRegion", {
        id: e
      }).then(res => {
        this.area = res.data.data;
      });
    },
    areaChange(e) {
      // alert(this.objValue["area_name"]);
    },
    //判断是否token
    isToken() {
      if (this.token) {
        this.step = 2;
      } else {
        this.step = 1;
      }
    },
    //注册
    registerBtn() {
      var params = {
        phone: this.phone,
        code: this.code,
        password: this.password,
        password_confirmation: this.password_confirmation
      };
      var isCheckedPhone = checkedPhone(this, this.phone); //验证手机号码
      if (isCheckedPhone) {
        var isCheckPwd = checkPwd(this, this.password); //验证密码
      } else {
        return false;
      }
      if (isCheckPwd) {
        var isConfirmPwd = confirmPwd(
          this,
          this.password,
          this.password_confirmation
        ); //验证确认密码是否一致
      } else {
        return false;
      }
      if (isConfirmPwd) {
        this.post(this, "/home/register/phone", params).then(res => {
          if (res.data.code == 0) {
            window.localStorage.setItem("pc_token", res.data.data.token);
            window.localStorage.setItem("e_id", res.data.data.enterprise_id);
            window.localStorage.setItem("phone", this.phone); //保存手机号码
            this.$message.success(res.data.msg);
            this.step = 2;
            window.localStorage.setItem("step", 1); //是否完善  1否 -1是  未完善强制跳转到完善页
            // alert(window.localStorage.getItem('pc_token'))
            this.getClass();
            this.getProvince();
          }
        });
      }
    },
    myUpload(content) {
      var formdata = new FormData();
      formdata.append("file", content.file);
      formdata.append("type", 4);
      this.axios
        .post(content.action, formdata, {
          onUploadProgress: progressEvent => {
            let num = ((progressEvent.loaded / progressEvent.total) * 100) | 0; //百分比
            content.onProgress({ percent: num }); //进度条
          }
        })
        .then(res => {
          content.onSuccess(res.data);
        });
    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      this.thumb = res.url;
    },
    // 三级分类不能相同
    fourChange(e, index) {
      let num = 0;
      for (let i in this.zsList) {
        if (e == this.zsList[i].four_level) {
          num++;
          if (num >= 2) {
            this.zsList[index].four_level = "";
            this.$message.error("类型不可以重复哦~");
          }
        }
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 0.05;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 50kb!");
      }
      if (isJPG && isLt2M) {
        this.addShow = false;
      }
      return isJPG && isLt2M;
    },
    sub() {
      this.$set(this.objValue, "logo", this.thumb);
      this.$set(this.objValue, "type_id", this.type);
      this.$set(this.objValue, "enterprise_content", this.enterprise_content);
      this.$set(this.objValue, "sms_phone", this.sms_phone);

      let SubObjClass = JSON.parse(JSON.stringify(this.objClass));
      let SubObjValue = JSON.parse(JSON.stringify(this.objValue));
      
      let type = false;
      if (!this.sms_phone) {
        this.$message.error("请输入业务手机");
        return false;
      }
      for (let q in SubObjClass) {
        if (
          SubObjClass[q].is_notnull == 1 &&
          !SubObjValue[SubObjClass[q].field_name]
        ) {
          this.$message.error(SubObjClass[q].c_name + "不能为空");
          return false;
        }
        if (q == SubObjClass.length - 1) {
          type = true;
        }
      }
      if (type) {
        if (SubObjValue["area_name"]) {
          if (
            SubObjValue["area_name"][2] == undefined ||
            !SubObjValue["area_name"][2]
          ) {
            this.$message.error("区域请填写完整");
            return false;
          }
        }

        for (let g in this.zsList) {
          if (!this.zsList[g].four_level || !this.zsList[g].three_level || !this.zsList[g].second_level) {
            this.$message.error("请选择名片类型");
            return false;
          }
        }

        if (
          SubObjValue["enterprise_phone"] &&
          !/^1[3456789][0-9]{9}$/.test(
            SubObjValue["enterprise_phone"]
          )
        ) {
          this.$message.error("请输入正确手机号");
          return false;
        }

        for (let p in SubObjValue) {
          if (p == "jyfl" && SubObjValue["jyfl"].length == 0) {
            this.$message.error("经营分类请填写完整");
            return false;
          }
        }
        // 数组都转为字符串格式
        for (let j in SubObjValue) {
          // 不对区域进行字符串拼接
          if (SubObjValue[j].constructor == Array && j != "area_name") {
            let name = SubObjValue[j].filter(item => item);
            SubObjValue[j] = "," + name.join(",") + ",";
          }
          if (j == "area_name") {
            let name = SubObjValue[j].filter(item => item);
            SubObjValue[j] = name.join(",");
          }
        }
        // 分类
        let attract = [];
        for (let i in this.zsList) {
          attract[i] = {
            second_level: this.zsList[i].second_level,
            three_level: this.zsList[i].three_level,
            four_level: this.zsList[i].four_level
          };
        }
        let basic = SubObjValue;
        this.post(this, "/home/submitPerfect", {
          token: window.localStorage.getItem("pc_token"),
          attract: attract,
          basic: basic
        }).then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            window.localStorage.setItem("step", -1);
            this.post(this, "/home/getEntinfo", {
              token: window.localStorage.getItem("pc_token")
            }).then(res => {
              window.localStorage.setItem(
                "ent_info",
                JSON.stringify(res.data.data.ent_info)
              );
              window.localStorage.setItem(
                "level",
                res.data.data.function_choice
                  ? res.data.data.function_choice
                  : false
              );
            });
            if (this.$route.query.pointAddress) {
              this.$router.push({
                name: this.$route.query.pointAddress
              });
              return false;
            }
            let time = setInterval(() => {
              if (window.localStorage.getItem("ent_info")) {
                this.$router.push({
                  name: "mine"
                });
                clearInterval(time);
              }
            }, 500);
          }
        });
      }
    },
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange(e, text) {
      if (e.html.indexOf("&lt;a") >= 0 || e.html.indexOf("<a") >= 0) {
        this.objValue[text] = this.objValue[text].replace(
          /(<\/?a.*?>)|(<\/?span.*?>)/g,
          ""
        );
      }
    }, // 内容改变事件
    onEditorBlurs() {}, // 失去焦点事件
    onEditorFocuss() {}, // 获得焦点事件
    onEditorChanges(e, text) {
      if (e.html.indexOf("&lt;a") >= 0 || e.html.indexOf("<a") >= 0) {
        this.objValue[text] = this.objValue[text].replace(
          /(<\/?a.*?>)|(<\/?span.*?>)/g,
          ""
        );
      }
    } // 内容改变事件
  }
};
</script>
<style scoped>
.shili {
  width: 120px;
  height: 120px;
}
.el-header {
  line-height: 80px;
}

.el-footer {
  background: #3d3f41;
}

.el-main {
  background: url(../../public/img/login_bg.jpg) no-repeat center top;
  background-size: cover;
  padding: 80px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 130px) !important;
}

.mid1200 {
  max-width: 1200px;
  margin: 0 auto;
}

.after:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.loginForm {
  margin: 0 auto;
  width: 610px;
}

.loginForm .title {
  font-weight: normal;
  color: #333;
  font-size: 24px;
  line-height: 2em;
  text-align: center;
  padding: 15px 0;
}

.formBox .form {
  background: #f7f7f7;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  overflow: hidden;
  padding: 0 35px 30px;
}

.formBox .form2 {
  background: #f7f7f7;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  overflow: hidden;
  padding: 20px 35px 30px;
}

.form li {
  padding: 15px 0;
  border-bottom: 1px solid #ddd;
  font-size: 18px;
  color: #999999;
  position: relative;
}

.form li.pl40 {
  padding-left: 40px;
}

.form li.pl95 {
  padding-left: 95px;
}

.form li.pr120 {
  padding-right: 120px;
}

.borb0 {
  border-bottom: 0 !important;
}

.form input {
  height: 40px;
  background: no-repeat;
  width: 100%;
  outline: 0;
}

.form li > i {
  font-size: 24px;
  position: absolute;
  left: 5px;
  top: 50%;
  margin-top: -12px;
}

.form li.forgetli {
  font-size: 16px;
  color: #333;
  padding: 30px 0;
}

.form li.phone_li span {
  color: #333333;
  font-size: 18px;
  height: 1em;
  line-height: 1em;
  position: absolute;
  left: 40px;
  top: 50%;
  margin-top: -0.5em;
  border-right: 1px solid #333;
  padding-right: 10px;
  display: block;
}

.loginBtn {
  display: block;
  width: 100%;
  border-radius: 2px;
  background: #ff7b00;
  font-size: 24px;
  color: #fff;
  letter-spacing: 5px;
  height: 60px;
}

.tip {
  margin-top: 30px;
  text-align: center;
  color: #fff;
  font-size: 16px;
}

.tip a {
  color: #ff7b00;
  cursor: default;
}

.stepLine {
  width: 428px;
  margin: 0 auto 35px;
}

.stepLine dl {
  float: left;
  width: 50%;
  position: relative;
}

.stepLine dl dt {
  width: 56px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  background: url(../../public/img/re_step1.png) no-repeat center;
  display: inline-block;
  margin: 0 5px;
  position: relative;
  z-index: 2;
  margin-bottom: 10px;
}

.stepLine dl dd {
  font-size: 16px;
  color: #ffffff;
  line-height: 2em;
}

.stepLine dl:before {
  position: absolute;
  width: 194px;
  height: 1px;
  content: "";
  background: #c0c1c1;
  top: 21px;
}

.stepLine dl.dl1:before {
  left: 20px;
}

.stepLine dl.dl2:before {
  right: 20px;
}

.stepLine dl.dl2 {
  text-align: right;
}

.stepLine dl.dl2 dt {
  background: url(../../public/img/re_step2.png) no-repeat center;
}

.stepLine.step1 dl.dl1 dt {
  background: url(../../public/img/re_step1_1.png) no-repeat center;
}

.stepLine.step2 dl.dl2 dt {
  background: url(../../public/img/re_step2_1.png) no-repeat center;
}

.stepLine.step1 dl.dl1:before {
  background: #ff7b00;
}

.stepLine.step2 dl.dl2:before {
  background: #ff7b00;
}
.form2 li {
  overflow: hidden;
}
.form2 li .item_left {
  /* width: 200px; */
  min-width: 140px;
  max-width: 140px;
  font-size: 18px;
  color: #333;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
}
.form2 li .item_left i {
  font-size: 24px;
  color: #999;
  margin-right: 10px;
}
.form2 li > input {
  width: 430px;
  font-size: 18px;
  color: #999;
}
.form2 li > input {
  padding: 0 15px;
}
.form2 li.tips_li {
  font-size: 14px;
  padding: 10px 0;
  color: #999;
}
.form2 li .uploadBox .avatar-uploader {
  display: inline-block;
  margin-right: 30px;
  vertical-align: middle;
}
.form2 li .uploadBox > img {
  display: inline-block;
  vertical-align: middle;
}
.form2 li .handle {
  line-height: 40px;
}
.form2 li .handle i {
  font-size: 32px;
  color: #666;
  margin-left: 10px;
}
.form2 .loginBtn {
  margin-top: 30px;
}
textarea {
  height: auto;
  min-height: 40px;
  line-height: 40px;
}
.form2 li .span_li {
  width: 100px;
  text-align: justify;
  text-align-last: justify;
  display: inline-block;
}
.form2 li .item_right {
  padding-left: 15px;
  padding-right: 30px;
  position: relative;
}
.xing {
  position: absolute;
  right: 0;
  top: 0;
  /* transform: translateY(-50%); */
  color: red;
  line-height: 40px;
}
.shili {
  display: inline-block;
  vertical-align: middle;
}
.iconImg {
  width: 24px;
  height: 24px;
  display: inline-block;
  object-fit: contain;
  margin-right: 10px;
  vertical-align: middle;
}
</style>
<style>
.reg .avatar-uploader {
  width: 120px;
  height: 120px;
}
.reg .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
  background: #fff;
}
.reg .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.reg .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.reg .avatar {
  width: 120px;
  height: 120px;
  display: block;
}
.address_picker .el-select {
  width: 143px;
}
.reg .form2 li .el-input__inner {
  border: 0;
  background: none;
  font-size: 18px;
  color: #999;
  padding-left: 0;
}
.jy_picker .el-select {
  width: 100px;
}
.form2 .item_li {
  display: flex;
}
.quill-editor .ql-editor {
  font-size: 18px;
  line-height: 1.5;
}
.ql-editor {
  min-height: 100px;
}
.reg .el-progress__text {
  transform: translate(200%, 200%) !important;
}
</style>
